var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanckClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 186,
    viewBox: "0 0 184 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M147.475 60.75C137.495 60.75 129.365 52.63 129.365 42.64C129.365 32.65 137.485 24.54 147.475 24.54C157.465 24.54 165.575 32.66 165.575 42.64C165.575 52.62 157.455 60.75 147.475 60.75ZM147.475 27.54C139.145 27.54 132.365 34.32 132.365 42.64C132.365 50.96 139.145 57.75 147.475 57.75C155.805 57.75 162.575 50.97 162.575 42.64C162.575 34.31 155.795 27.54 147.475 27.54Z",
    fill: "#E8C65B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M153.445 54.63L144.625 45.81V31.72H147.625V44.57L155.565 52.5L153.445 54.63Z",
    fill: "#E8C65B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M155.735 96.79H26.715C23.295 96.79 20.515 94.01 20.515 90.59V88.87C20.515 86.31 21.895 83.93 24.115 82.65L86.365 46.82C89.365 45.1 93.085 45.1 96.075 46.82L158.335 82.65C160.555 83.93 161.925 86.31 161.925 88.87V90.59C161.925 94.01 159.145 96.79 155.725 96.79H155.735ZM91.225 49.53C90.235 49.53 89.245 49.78 88.365 50.29L26.105 86.12C25.125 86.68 24.515 87.74 24.515 88.87V90.59C24.515 91.8 25.505 92.79 26.715 92.79H155.735C156.945 92.79 157.935 91.8 157.935 90.59V88.87C157.935 87.74 157.325 86.68 156.345 86.12L94.085 50.29C93.205 49.78 92.215 49.53 91.225 49.53Z",
    fill: "#0058A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.575 149.12C34.475 149.12 33.575 148.22 33.575 147.12V101.65C33.575 100.55 34.475 99.65 35.575 99.65C36.675 99.65 37.575 100.55 37.575 101.65V147.12C37.575 148.22 36.675 149.12 35.575 149.12Z",
    fill: "#0058A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M46.025 149.12C44.925 149.12 44.025 148.22 44.025 147.12V101.65C44.025 100.55 44.925 99.65 46.025 99.65C47.125 99.65 48.025 100.55 48.025 101.65V147.12C48.025 148.22 47.125 149.12 46.025 149.12Z",
    fill: "#0058A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.995 149.12C84.895 149.12 83.995 148.22 83.995 147.12V101.65C83.995 100.55 84.895 99.65 85.995 99.65C87.095 99.65 87.995 100.55 87.995 101.65V147.12C87.995 148.22 87.095 149.12 85.995 149.12Z",
    fill: "#0058A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M96.455 149.12C95.355 149.12 94.455 148.22 94.455 147.12V101.65C94.455 100.55 95.355 99.65 96.455 99.65C97.555 99.65 98.455 100.55 98.455 101.65V147.12C98.455 148.22 97.555 149.12 96.455 149.12Z",
    fill: "#0058A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M136.075 149.12C134.975 149.12 134.075 148.22 134.075 147.12V101.65C134.075 100.55 134.975 99.65 136.075 99.65C137.175 99.65 138.075 100.55 138.075 101.65V147.12C138.075 148.22 137.175 149.12 136.075 149.12Z",
    fill: "#0058A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M146.525 149.12C145.425 149.12 144.525 148.22 144.525 147.12V101.65C144.525 100.55 145.425 99.65 146.525 99.65C147.625 99.65 148.525 100.55 148.525 101.65V147.12C148.525 148.22 147.625 149.12 146.525 149.12Z",
    fill: "#0058A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M161.465 159.61H20.415C19.315 159.61 18.415 158.71 18.415 157.61C18.415 156.51 19.315 155.61 20.415 155.61H161.465C162.565 155.61 163.465 156.51 163.465 157.61C163.465 158.71 162.565 159.61 161.465 159.61Z",
    fill: "#0058A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanckClock);
export default __webpack_public_path__ + "static/media/banckClock.9f958f7f9db7c8b1e4a889cc950e0b61.svg";
export { ForwardRef as ReactComponent };